import { z } from 'zod';

import {
  EntityBaseSchema,
  EntityMetadataSchema,
  NonEmptyStringSchema,
  ReferenceSchema,
  StringSchema,
} from '../../base';

export const LocalizedTextSchema = z.object({
  languageCode: NonEmptyStringSchema,
  text: StringSchema,
  isAutoTranslated: z
    .boolean()
    .describe('Whether the text was machine-translated vs manually entered'),
});

export type LocalizedText = z.infer<typeof LocalizedTextSchema>;

export const TranslationReferencesSchema = z.object({
  topics: ReferenceSchema,
  sms: ReferenceSchema,
  greetings: ReferenceSchema,
  disclaimerMessages: ReferenceSchema,
  behaviour: ReferenceSchema,
});

export type TranslationReferences = z.infer<typeof TranslationReferencesSchema>;

export type TranslationRefKey = keyof TranslationReferences;

export const TranslationBaseSchema = EntityBaseSchema.extend({
  translationKey: NonEmptyStringSchema.describe(
    'Unique identifier for a translation group (e.g., "greeting_message")',
  ),
  translations: z.array(LocalizedTextSchema),
  references: TranslationReferencesSchema.optional(),
});

export const TranslationSchema =
  TranslationBaseSchema.merge(EntityMetadataSchema);

export type Translation = z.infer<typeof TranslationSchema>;
